const NOTIFICATION_ICON_MAPPING = {
  alert: 'icon-warning',
  error: 'icon-error',
  notice: 'icon-warning',
  success: 'icon-complete-circle'
};

export default (options = {}) => {
  let iconHref = NOTIFICATION_ICON_MAPPING[options['type']] || NOTIFICATION_ICON_MAPPING['success'];

  return (
    `
      <div class="notification">
        <div class="notification__close">
          <button type="button" class="btn">&times;</button>
        </div>
        <div class="notification__icon">
          <svg width="40" height="35" viewBox="0 0 40 35">
            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#${iconHref}"></use>
          </svg>
        </div>

        <div class="notification__${options['type']}">${options['message']}</div>
      </div>
    `
  );
};



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/notification/template.js